// hooks/useS3Image.js
import { useState, useEffect } from 'react';

const LISTING_URL =
    process.env.REACT_APP_LISTING_SERVICE || "http://localhost:4001";

export function useS3Image(s3Key, folder = 'images') {
    const [resourceUrl, setResourceUrl] = useState("/images/placeholder.png");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!s3Key) {
            setResourceUrl("/images/placeholder.png");
            setLoading(false);
            return;
        }

        const fetchImageUrl = async () => {
            setLoading(true);
            setError(null);

            try {
                const fullKey = `${folder}/${s3Key}`;
                const apiUrl = process.env.REACT_APP_API_URL || LISTING_URL;

                const response = await fetch(
                    `${apiUrl}/media-service/file?key=${encodeURIComponent(fullKey)}`
                );

                const data = await response.json();
               

                if (data.success && data.data.url) {
                    setResourceUrl(data.data.url);
                } else {
                    throw new Error(data.message || 'Failed to get image URL');
                }
            } catch (err) {
                console.error('Error fetching S3 image:', err);
                setError(err.message);
                setResourceUrl("/images/placeholder.png");
            } finally {
                setLoading(false);
            }
        };

        fetchImageUrl();
    }, [s3Key, folder]);

    return { resourceUrl, loading, error };
}